import { render, staticRenderFns } from "./Yookassa.vue?vue&type=template&id=0034a5fc&"
import script from "./Yookassa.vue?vue&type=script&lang=js&"
export * from "./Yookassa.vue?vue&type=script&lang=js&"
import style0 from "./Yookassa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports